/**
 * Arredonda para centavos com o mesmo resultado do round($valor, 2) do PHP da API
 * (meio para longe do zero, com pré-arredondamento a 15 dígitos para neutralizar o erro de ponto flutuante).
 *
 * @param {number} value
 * @returns {number}
 */
export function roundMoney(value) {
  const number = Number(value);

  if (!Number.isFinite(number)) return 0;

  const cents = Math.round(Number((Math.abs(number) * 100).toPrecision(15)));

  return (Math.sign(number) * cents) / 100;
}
